import banner1 from './assets/banner1.png';
import banner2 from './assets/banner2.png';
import banner3 from './assets/banner3.png';
import banner4 from './assets/banner4.png';
import bgBanner from "./assets/behzadlift's_banner.png";

export default function HeroSection() {
  const transformations = [
    { year: "2022", weight: "120KG", image: banner1 },
    { year: "2023", weight: "70KG",  image: banner2 },
    { year: "2024", weight: "120KG", image: banner3 },
    { year: "2025", weight: "92KG",  image: banner4 },
  ];

  return (
    <section className="relative h-auto sm:min-h-screen flex items-start sm:items-center overflow-hidden">
      <div className="absolute inset-0 sm:inset-0">
        <img
          src={bgBanner}
          alt="Section Background"
          className="w-full h-full object-cover object-center sm:object-cover"
        />
        <div className="absolute inset-0" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-8 sm:py-16 w-full z-10">
        <h1 className="text-2xl sm:text-5xl md:text-7xl lg:text-8xl font-black text-center text-white mb-6 sm:mb-16 tracking-tighter">
          I HAVE <span className="text-[#fc0100]">SEEN</span> IT ALL
        </h1>

        <div className="flex flex-wrap justify-center gap-2 sm:gap-4 md:gap-6 lg:gap-8 max-w-6xl mx-auto">
          {transformations.map((item, index) => (
            <div
              key={index}
              className="rounded-lg sm:rounded-2xl p-2 sm:p-3 md:p-4 w-[calc(50%-0.5rem)] sm:w-[calc(50%-1rem)] lg:w-[calc(25%-1.5rem)] max-w-[280px] border border-white/20 relative overflow-hidden"
              style={{
                background: 'rgb(255 255 255 / 8%)',
                backdropFilter: 'blur(15px)',
                WebkitBackdropFilter: 'blur(15px)',
              }}
            >
              <div className="absolute inset-0 pointer-events-none" style={{ background: 'linear-gradient(125deg, rgba(255,255,255,0.03) 0%, rgba(255,255,255,0.01) 40%, rgba(255,255,255,0.02) 60%, transparent 100%)', mixBlendMode: 'overlay' }} />
              <div className="absolute inset-0 pointer-events-none" style={{ background: 'radial-gradient(circle at 30% 30%, rgba(255,255,255,0.08) 0%, transparent 70%)', mixBlendMode: 'soft-light', opacity: 0.6 }} />
              <div className="absolute inset-0 pointer-events-none" style={{ boxShadow: 'inset 0 4px 15px -3px rgba(255,255,255,0.1), inset 0 -2px 5px rgba(0,0,0,0.4)' }} />
              <div className="absolute inset-0 pointer-events-none" style={{ background: 'linear-gradient(45deg, rgba(255,0,0,0.01) 0%, rgba(0,255,0,0.01) 25%, rgba(0,0,255,0.01) 50%, rgba(255,0,255,0.01) 75%, rgba(255,255,0,0.01) 100%)', mixBlendMode: 'screen', opacity: 0.3 }} />
              <div className="absolute inset-0 pointer-events-none" style={{ background: 'radial-gradient(circle at 50% 50%, rgba(255,255,255,0.02) 0%, transparent 80%)', backdropFilter: 'blur(1px)', WebkitBackdropFilter: 'blur(1px)', mixBlendMode: 'overlay' }} />

              <div className="relative z-10">
                <img
                  src={item.image}
                  alt={`Transformation ${item.year}`}
                  className="w-full aspect-square object-cover rounded-md sm:rounded-xl mb-2 sm:mb-3 md:mb-4"
                />

                <div className="flex items-center justify-between px-1 sm:px-2">
                  <div className="text-center flex-1">
                    <div style={{ fontSize: 'clamp(12px, 3vw, 20px)', lineHeight: '1.2', fontFamily: 'Roboto, sans-serif', fontWeight: '900', color: '#FFFFFF' }}>
                      YEAR
                    </div>
                    <div style={{ fontSize: 'clamp(10px, 2.5vw, 15.96px)', lineHeight: '1.2', letterSpacing: '8%', color: '#FF0000', fontFamily: 'Poppins, sans-serif', fontWeight: '900' }}>
                      {item.year}
                    </div>
                  </div>

                  <div className="mx-0.5" style={{ width: '1px', height: 'clamp(25px, 6vw, 40px)', background: 'linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0.5) 50%, rgba(255,255,255,0) 100%)' }} />

                  <div className="text-center flex-1">
                    <div style={{ fontSize: 'clamp(12px, 3vw, 20px)', lineHeight: '1.2', fontFamily: 'Roboto, sans-serif', fontWeight: '900', color: '#FFFFFF' }}>
                      WEIGHT
                    </div>
                    <div style={{ fontSize: 'clamp(10px, 2.5vw, 15.96px)', lineHeight: '1.2', letterSpacing: '8%', color: '#FF0000', fontFamily: 'Poppins, sans-serif', fontWeight: '900' }}>
                      {item.weight}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
